/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { HubbleMenuBarData } from "../models/index";
import {
  HubbleMenuBarDataFromJSON,
  HubbleMenuBarDataToJSON,
} from "../models/index";

/**
 *
 */
export class StatsApi extends runtime.BaseAPI {
  /**
   */
  async getMenubarStatsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<HubbleMenuBarData>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/stats/get-menubar-stats`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      HubbleMenuBarDataFromJSON(jsonValue),
    );
  }

  /**
   */
  async getMenubarStats(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<HubbleMenuBarData> {
    const response = await this.getMenubarStatsRaw(initOverrides);
    return await response.value();
  }
}
